import * as axios from 'axios'
import { API, SECRET, CONFIG } from './config';

const header = { secret: SECRET, token: CONFIG.token };

const getUserEvents = async (token) =>
{
    const data = { ...header, ...{ user_token: token } };

    let events = [];

    await axios
        .post(`${API}events/user`, data)
        .then(function(response)
        {
            events = response.data.map(h =>
            {
                return h;
            });
        })
        .catch(function(e) {
            console.error(e);
        });

    // console.log(events);
    return events;
};

const getEvents = async (isAdmin, userId, userEvents, startDate, endDate) =>
{
    let events = [];
    let privacy = isAdmin;

    // privacy
    if (typeof CONFIG.privacy == 'string' && !privacy)
    {
        // visible for public
        if (CONFIG.privacy == 'public') {
            privacy = true;
        }

        // visible only for registered users
        if (CONFIG.privacy == 'login' && userId > 0) {
            privacy = true;
        }
    }

    const data = { ...header, ...{ admin: privacy, start: startDate, end: endDate } };

    await axios
        .post(`${API}events`, data)
        .then(function(response)
        {
            events = response.data.map(h =>
            {
                let classArr = [];

                classArr.push(h.flag);

                let title = 'Reserviert';
                let name = h.name;
                let lastname = h.lastname;

                if (CONFIG.format.usernames === 'short') {
                    name = name.charAt(0) + '.';
                    lastname = lastname.charAt(0) + '.';
                }

                if (privacy)
                {
                    title = (h.title == null) ? `${name} ${lastname}` : `${name} ${lastname} / ${h.title}`;
                }
                else if (userEvents.length > 0)
                {
                    userEvents.forEach((item) => {
                        if (item.id == h.id)
                        {
                            title = (item.title == null) ? 'Deine Reservierung' : `Deine Reservierung / ${item.title}`;

                            classArr.push('user');
                        }
                    });
                }

                switch (h.flag) {
                    case 'blocked':
                        title = 'Gesperrt';
                        break;
                }

                h.title = title;
                h.resourceId = h.resource;
                h.start = h.date + 'T' + h.from;
                h.end = h.date + 'T' + h.to;
                h.classNames = classArr;

                return h;
            });
        })
        .catch(function(e) {
            console.error(e);
        });

    // console.log(events);
    return events;
};

const addEvent = async (event) =>
{
    try {
        const data = { ...header, ...event };

        return await axios
            .post(`${API}events/create`, data)
            .then(function(response)
            {
                // console.log(response);
                return response.status;
            })
            .catch(function(e) {
                // console.error(e);
                return e.response;
            });
    }
    catch (e) {
        console.error(e);
        return [];
    }
};

const deleteEvent = async (token) =>
{
    try {
        return await axios
            .get(`${API}events/delete/${token}`)
            .then(function(response)
            {
                // console.log(response);
                return response.status;
            })
            .catch(function(e) {
                // console.error(e);
                return e.response;
            });
    }
    catch (e) {
        console.error(e);
        return [];
    }
};

const getSlots = async (arg) =>
{
    try {
        const data = { ...header, ...arg };

        let slots = [];

        await axios
            .post(`${API}events/slots`, data)
            .then(function(response)
            {
                // console.log(JSON.stringify(response.data.available));
                slots = response.data;
            })
            .catch(function(e) {
                console.error(e);
            });

        return slots;
    }
    catch (e) {
        console.error(e);
        return [];
    }
};

const checkUserEmail = async (email) =>
{
    try {
        return await axios
            .get(`${API}check/${email}`)
            .then(function(response)
            {
                return response;
            })
            .catch(function(e) {
                // console.error(e);
                return e.response;
            });
    }
    catch (e) {
        console.error(e);
        return [];
    }
};

const login = async (form) =>
{
    try {
        const data = { ...header, ...form };

        return await axios
            .post(`${API}login`, data)
            .then(function(response)
            {
                return response;
            })
            .catch(function(e) {
                // console.error(e);
                return e.response;
            });
    }
    catch (e) {
        console.error(e);
        return [];
    }
};

const register = async (form) =>
{
    try {
        const data = { ...header, ...form };

        return await axios
            .post(`${API}register`, data)
            .then(function(response)
            {
                // console.log(response);
                return response.status;
            })
            .catch(function(e) {
                // console.error(e);
                return e.response;
            });
    }
    catch (e) {
        console.error(e);
        return [];
    }
};

export const dataService = {
    getEvents,
    getUserEvents,
    addEvent,
    deleteEvent,
    getSlots,
    login,
    register,
    checkUserEmail,
};
